import {config} from "./config";
import {request} from "./request";

function createFreeOrder(data, cb, fail_cb) {
    request.get.call(this, config.apiList.createPddFreeOrders, data, cb, fail_cb)
}

function createPddPromotion(data, cb, fail_cb) {
    request.get.call(this, config.apiList.createPddPromotion, data, cb, fail_cb)
}

function createPddChannelPromotion(data, cb, fail_cb) {
    request.get.call(this, config.apiList.createPddChannelPromotion, data, cb, fail_cb)
}

function createPddRedPacketPromotion(data, cb, fail_cb) {
    request.get.call(this, config.apiList.createPddRedPacketPromotion, data, cb, fail_cb)
}

var pddApi = {
    createFreeOrder: createFreeOrder,
    createPddRedPacketPromotion: createPddRedPacketPromotion,
    createPddChannelPromotion: createPddChannelPromotion,
    createPddPromotion: createPddPromotion
}

export {pddApi}